export default {
  EXAMPLE_ERROR(state, payload) {
    state.example = true
  },
  EXAMPLE_MUTATION(state, payload) {
    state.example = false
  },
  TOGGLE_MOBILE_NAV (state, payload) {
    state.displayMobileNav = !state.displayMobileNav
  },
  RESET_MOBILE_NAV (state, payload) {
    state.displayMobileNav = false
  },
  SET_TOAST (state, { title, message }) {
    state.toast = { title, message }
  },
  TOAST_LOGIN (state, payload) {
    state.toast = { title: 'Login', message: payload }
  },
  TOAST_LOGOUT (state, payload) {
    state.toast = { title: 'Logout', message: payload }
  },
  TOAST_ACCOUNT (state, payload) {
    state.toast = { title: 'Account', message: payload }
  },
  TOAST_USER (state, payload) {
    state.toast = { title: 'User', message: payload }
  },
  TOAST_GROUP (state, payload) {
    state.toast = { title: 'Group', message: payload }
  },
  TOAST_FILE (state, payload) {
    state.toast = { title: 'File', message: payload }
  },
  TOAST_PASSWORD (state, payload) {
    state.toast = { title: 'Password Reset', message: payload }
  },
  TOAST_VERIFY (state, payload) {
    state.toast = { title: 'Verify', message: payload }
  },
  TOAST_SUBSCRIPTION (state, payload) {
    state.toast = { title: 'Subscription', message: payload }
  },
  TOAST_MESSAGE (state, payload) {
    state.toast = { title: 'New Message', message: payload }
  },
  TOAST_ERROR (state, payload) {
    state.toast = { title: 'Error', message: payload }
  },
  TOGGLE_SPINNER (state, payload) {
    state.showSpinner = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/store/misc/mutations.js